// import { Card, CardBody, CardExpandToggler } from '../../../../components/card/card.jsx';
// import { Icon } from '@iconify/react';

// import { useTranslation } from 'react-i18next';
// import CountUp from 'react-countup';
// import { useEffect, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { useSelector } from 'react-redux';
// import { getEmployees } from '../../../../store/HR/Person/employeeSlice.js';
// import Loading from '../../../../components/Shared/Loader/Loading';
// import Bar from '../../../dashboard/Bar.jsx';
// import Pie from '../../../dashboard/Pie.jsx';
// import Line from '../../../dashboard/Line.jsx';
// import Breadcrumb from '../../../../components/Shared/Breadcrumb';

// const Main = () => {
//   const { t, i18n } = useTranslation();

//   const dispatch = useDispatch();
//   useEffect(() => {
//     const fetchData = async () => {
//       if (Employees?.length === 0) {
//         await dispatch(getEmployees());
//       }
//     };
//     fetchData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [dispatch]);
//   const { Employees, loading, error } = useSelector((state) => state.Employees);
//   var totalEmployees = Employees?.length;

//   //~~
//   const pieOptions = {
//     labels: ['إدارية', 'تقنية', 'إنتاجية'],
//     Series: [30, 45, 25],
//   };

//   // Bar Chart: مقارنة الرواتب حسب الأقسام
//   const bar = {
//     categories: ['إدارية', 'تقنية', 'إنتاجية'],
//     Series: [
//       {
//         name: 'أقل راتب',
//         data: [2000, 3000, 2500],
//       },
//       {
//         name: 'متوسط الراتب',
//         data: [4000, 5000, 4500],
//       },
//       {
//         name: 'أعلى راتب',
//         data: [8000, 9000, 8500],
//       },
//     ],
//   };

//   const [lineChartData, setLineChartData] = useState({
//     categories: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو'],

//     series: [
//       {
//         name: 'إجمالي الرواتب',
//         data: [12000, 14000, 13000, 15000, 16000],
//       },
//     ],
//   });

//   return (
//     <div>
//       <Breadcrumb
//         BreadcrumbList={[
//           {
//             name: 'Home',
//             link: null,
//           },
//         ]}
//       />
//       <Loading loading={loading} error={error}>
//         <>
//           <div className="row">
//             <div className="col-lg-3">
//               <Card className="mb-3 border-theme">
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 text-theme">عدد الموظفين</span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 ps-4 text-success">
//                         <CountUp end={totalEmployees} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <div className="mt-n2 ps-4">
//                         <Icon
//                           icon="ph:users-duotone"
//                           className="me-2 text-success "
//                           style={{ fontSize: '5rem' }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-lg-3">
//               <Card className="mb-3 border-danger">
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 text-theme">متوسط الرواتب لكل موظف</span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 ps-4 text-danger">
//                         <CountUp end={200} duration={2.5} decimals={2} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <div className="mt-n2 ps-4">
//                         <Icon
//                           icon="ph:currency-dollar-duotone"
//                           className="me-2 text-danger "
//                           style={{ fontSize: '5rem' }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-lg-3">
//               <Card className="mb-3 border-indigo">
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 text-theme">إجمالي الخصومات</span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 ps-4 text-indigo">
//                         <CountUp end={2300} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <div className="mt-n2 ps-4">
//                         <Icon
//                           icon="ph:percent-duotone"
//                           className="me-2 text-indigo "
//                           style={{ fontSize: '5rem' }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-lg-3">
//               <Card className="mb-3 border-purple">
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 text-theme">إجمالي البدلات</span>
//                   </div>
//                   <div className="row align-items-center">
//                     <div className="col-7">
//                       <h1 className="mb-0 ps-4 text-purple">
//                         <CountUp end={5600} duration={2.5} />
//                       </h1>
//                     </div>
//                     <div className="col-5 text-center">
//                       <div className="mt-n2 ps-4">
//                         <Icon
//                           icon="ph:gift-duotone"
//                           className="me-2 text-purple "
//                           style={{ fontSize: '5rem' }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>

//           <div className="row g-3">
//             <div className="col-12 col-md-6 col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">مقارنة الرواتب حسب الأقسام</span>
//                     <CardExpandToggler />
//                   </div>

//                   <Bar categories={bar.categories} series={bar.Series} height={400} isStacked />
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-12 col-md-6 col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">توزيـع الرواتب</span>
//                     <CardExpandToggler />
//                   </div>
//                   <Pie labels={pieOptions.labels} series={pieOptions.Series} height={500} />
//                 </CardBody>
//               </Card>
//             </div>

//             <div className="col-12 col-md-6 col-lg-4">
//               <Card className="mb-3" style={{ height: '100%' }}>
//                 <CardBody>
//                   <div className="d-flex fw-bold small mb-3">
//                     <span className="flex-grow-1 fs-6 fw-bold">الرواتب الشهـريــة</span>
//                     <CardExpandToggler />
//                   </div>
//                   <div className="ratio ratio-21x9 mb-3">
//                     <Line categories={lineChartData.categories} series={lineChartData.series} />
//                   </div>
//                 </CardBody>
//               </Card>
//             </div>
//           </div>
//         </>
//       </Loading>
//     </div>
//   );
// };

// export default Main;





import { Card, CardBody, CardExpandToggler } from '../../../../components/card/card.jsx';
import { Icon } from '@iconify/react';

import { useTranslation } from 'react-i18next';
import CountUp from 'react-countup';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getEmployees } from '../../../../store/HR/Person/employeeSlice.js';
import Loading from '../../../../components/Shared/Loader/Loading';
import Bar from '../../../dashboard/Bar.jsx';
import Pie from '../../../dashboard/Pie.jsx';
import Line from '../../../dashboard/Line.jsx';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';

const Main = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      if (Employees?.length === 0) {
        await dispatch(getEmployees());
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const { Employees, loading, error } = useSelector((state) => state.Employees);
  var totalEmployees = Employees?.length;

  // تحديد النصوص بناءً على اللغة
  const pieLabels = i18n.language === 'en' ? ['Administrative', 'Technical', 'Productive'] : ['إدارية', 'تقنية', 'إنتاجية'];
  const barCategories = i18n.language === 'en' ? ['Administrative', 'Technical', 'Productive'] : ['إدارية', 'تقنية', 'إنتاجية'];
  const barSeriesNames = i18n.language === 'en' ? ['Lowest Salary', 'Average Salary', 'Highest Salary'] : ['أقل راتب', 'متوسط الراتب', 'أعلى راتب'];
  const lineCategories = i18n.language === 'en' ? ['January', 'February', 'March', 'April', 'May'] : ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو'];
  const lineSeriesName = i18n.language === 'en' ? 'Total Salaries' : 'إجمالي الرواتب';

  //~~
  const pieOptions = {
    labels: pieLabels,
    Series: [30, 45, 25],
  };

  // Bar Chart: مقارنة الرواتب حسب الأقسام
  const bar = {
    categories: barCategories,
    Series: [
      {
        name: barSeriesNames[0],
        data: [2000, 3000, 2500],
      },
      {
        name: barSeriesNames[1],
        data: [4000, 5000, 4500],
      },
      {
        name: barSeriesNames[2],
        data: [8000, 9000, 8500],
      },
    ],
  };

  const [lineChartData, setLineChartData] = useState({
    categories: lineCategories,
    series: [
      {
        name: lineSeriesName,
        data: [12000, 14000, 13000, 15000, 16000],
      },
    ],
  });

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: i18n.language === 'en' ? 'Home' : 'الرئيسية',
            link: null,
          },
        ]}
      />
      <Loading loading={loading} error={error}>
        <>
          <div className="row">
            <div className="col-lg-3">
              <Card className="mb-3 border-theme">
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 text-theme">
                      {i18n.language === 'en' ? 'Total Employees' : 'عدد الموظفين'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-success">
                        <CountUp end={totalEmployees} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="ph:users-duotone"
                          className="me-2 text-success "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-3">
              <Card className="mb-3 border-danger">
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 text-theme">
                      {i18n.language === 'en' ? 'Average Salary per Employee' : 'متوسط الرواتب لكل موظف'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-danger">
                        <CountUp end={200} duration={2.5} decimals={2} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="ph:currency-dollar-duotone"
                          className="me-2 text-danger "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-3">
              <Card className="mb-3 border-indigo">
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 text-theme">
                      {i18n.language === 'en' ? 'Total Deductions' : 'إجمالي الخصومات'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-indigo">
                        <CountUp end={2300} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="ph:percent-duotone"
                          className="me-2 text-indigo "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>

            <div className="col-lg-3">
              <Card className="mb-3 border-purple">
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 text-theme">
                      {i18n.language === 'en' ? 'Total Allowances' : 'إجمالي البدلات'}
                    </span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-7">
                      <h1 className="mb-0 ps-4 text-purple">
                        <CountUp end={5600} duration={2.5} />
                      </h1>
                    </div>
                    <div className="col-5 text-center">
                      <div className="mt-n2 ps-4">
                        <Icon
                          icon="ph:gift-duotone"
                          className="me-2 text-purple "
                          style={{ fontSize: '5rem' }}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
          <div className="row g-3">
            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Salary Comparison by Department' : 'مقارنة الرواتب حسب الأقسام'}
                    </span>
                    <CardExpandToggler />
                  </div>

                  <Bar categories={bar.categories} series={bar.Series} height={400} isStacked />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Salary Distribution' : 'توزيـع الرواتب'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <Pie labels={pieOptions.labels} series={pieOptions.Series} height={500} />
                </CardBody>
              </Card>
            </div>

            <div className="col-12 col-md-6 col-lg-4">
              <Card className="mb-3" style={{ height: '100%' }}>
                <CardBody>
                  <div className="d-flex fw-bold small mb-3">
                    <span className="flex-grow-1 fs-6 fw-bold">
                      {i18n.language === 'en' ? 'Monthly Salaries' : 'الرواتب الشهـريــة'}
                    </span>
                    <CardExpandToggler />
                  </div>
                  <div className="ratio ratio-21x9 mb-3">
                    <Line categories={lineChartData.categories} series={lineChartData.series} />
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </>
      </Loading>
    </div>
  );
};

export default Main;